
import {
  defineAsyncComponent,
  defineComponent,
  PropType,
  SetupContext,
} from 'vue';

/** Interfaces */
import { LinceObligationI } from '@/interfaces/general.interface';

/** Composables */
import { usePaymentCard } from '@/composition/usePaymentCard';
import { useUtilities } from '@/composition/useUtilities';
import { ObligationTypes } from '@/utils/multi-pdf-types';

export default defineComponent({
  name: 'LinceObligationCard',
  components: {
    Tooltips: defineAsyncComponent(
      () => import('@/components/shared/Tooltips.vue')
    ),
    Phone: defineAsyncComponent(
      () => import('@/components/shared/icons/Phone.vue')
    ),
    Loader: defineAsyncComponent(
      () => import('@/components/loader/Loader.vue')
    ),
  },
  props: {
    linceObligations: {
      type: Array as PropType<LinceObligationI[]>,
      required: true,
    },
    isLoadingPaymentStatus: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['view-detail-plan', 'make-payment'],
  setup(_props, context: SetupContext) {
    const obligationType = ObligationTypes.AVAL_LINCE;
    const { validatePaymentDate } = useUtilities();

    const useClickToCall = () => {
      const url = 'https://customers.wolkvox.com/clicktocall/referencia';
      window.open(url, '_blank', 'noreferrer');
    };

    const {
      bindClassState,
      viewDetailPlan,
      makePayment,
      valueGreaterThanZero,
      getReference,
      canMakePayment,
      getLastPaymentStatus,
    } = usePaymentCard(context);

    return {
      obligationType,
      bindClassState,
      viewDetailPlan,
      makePayment,
      validatePaymentDate,
      valueGreaterThanZero,
      useClickToCall,
      getReference,
      canMakePayment,
      getLastPaymentStatus,
    };
  },
});
